import { FC } from 'react'
import { Link } from '@/components/Link'
import { BlogPostMetadata } from '../BlogPost/PostMetadata'
import { CmsBlogPost } from '../types'
import styles from './BlogPostCard.module.scss'

export interface CardTextProps {
  post: CmsBlogPost
  showMetadata?: boolean
  url: string
  imageCritical?: boolean
  showDate?: boolean
  pageResource?: boolean
}

export const BlogPostCardText: FC<CardTextProps> = ({
  post,
  url,
  showMetadata = true,
  imageCritical,
  showDate = false,
  pageResource,
}) => (
  <div className={styles.text}>
    {imageCritical ? (
      <h5 itemProp="headline" className={styles.imageCritical}>
        {/* Link below is not tabbable; the whole BlogPostCard acts as tabbable link */}
        <Link
          className={styles.blogLink}
          url={url}
          tabIndex={-1}
          itemProp="url"
        >
          {post.fields.title}
        </Link>
      </h5>
    ) : (
      <p itemProp="headline" role="heading" aria-level={5}>
        {/* Link below is not tabbable; the whole BlogPostCard acts as tabbable link */}
        <Link
          className={styles.blogLink}
          url={url}
          tabIndex={-1}
          itemProp="url"
        >
          {post.fields.title}
        </Link>
      </p>
    )}

    {showMetadata && (
      <BlogPostMetadata
        showDate={showDate}
        categories={post.fields.categories}
        className={styles.metadata}
        readingTime={post.fields.readingTime}
        createdAt={post.fields.publishedDate || post.sys.createdAt}
      />
    )}
    {pageResource && <div>Website Resource</div>}
  </div>
)
